'use client';

import * as Sentry from '@sentry/browser';
import { usePathname, useSearchParams } from 'next/navigation';
import { usePostHog } from 'posthog-js/react';
import { useEffect } from 'react';

import { useFlags } from '@/hooks/useFlags';

export function PostHogPageView() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const posthog = usePostHog();
  const { ID, flags, cohort } = useFlags();

  // track identify event
  useEffect(() => {
    if (!ID) {
      return;
    }

    posthog.identify(ID, {
      ...flags,
      ffCohort: cohort,
      ffID: ID,
      revision: process.env.VERCEL_GIT_COMMIT_SHA,
    });
    posthog.setPersonPropertiesForFlags(flags);
  }, [ID, flags, posthog, cohort]);

  // Track page views
  useEffect(() => {
    if (pathname && posthog) {
      let url = window.origin + pathname;

      if (searchParams.toString()) {
        url = `${url}?${searchParams.toString()}`;
      }

      try {
        posthog.capture('$pageview', {
          $current_url: url,
        });
      } catch (error) {
        Sentry.captureException(
          new Error('failed to send to posthog', { cause: error }),
        );
      }
    }
  }, [pathname, searchParams, posthog]);

  return null;
}
